import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/dockide.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class DockIDE extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 225 225' />
  }
}
